import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Header from '../../header';
import Footer from '../../footer';
import styles from '@/styles/Template.module.css';
import ServiceManagementAutomatic from '@/pages/images/serviceManagementAutomatic';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from "swiper";
import { Navigation, Autoplay } from "swiper";
import "swiper/css";
import RightArrow from '@/pages/images/rightArrow';
import StepFirst from '@/pages/images/stepFirst';
import StepSecond from '@/pages/images/stepSecond';
import StepThird from '@/pages/images/stepThird';
import Image, { ImageLoaderProps } from 'next/image';
import { IMAGE_DELIVERY, imageLoader } from "@/base/utils/dataHelper";
import PageSeo from '@/components/seo/PageSeo';

const HrServiceDelivery = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const isLanguage = router.locale?.toUpperCase().toString();

  type PreviewTab = 'form' | 'workflow';
  const [activePreviewTab, setActivePreviewTab] = useState<PreviewTab>('form');

  return (
    <>
      <PageSeo title={`${t("hrServiceDelivery")} | Stoneity`} description={t("hrServiceOverview")} locale={router.locale} />
      <Header />
      <div className={styles.mainFlex}>
        <div className={styles.templateBannerBackground}>
          <div className={styles.templateBannerWrapper}>
            <div className={styles.templateBannerLeft}>
              <div className={styles.templateBannerTitle}>{t("digitizeHrRequests")}</div>
              <div className={styles.templateBannerDescription}>{t("standardizeHrProcesses")}</div>
            </div>
            <div className={styles.circleContent}>
              <div className={styles.circleBackground}></div>
              <div className={styles.circleRing}><span className={styles.ring}></span></div>
              <div className={styles.circleUserWrapper}>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-6.png" alt="" />
                  </div>
                  {t("projectManagementText")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-4.png" alt="" />
                  </div>
                  {t("taskManagement")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-2.png" alt="" />
                  </div>
                  {t("operations")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-5.png" alt="" />
                  </div>
                  {t("portfolio")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-3.png" alt="" />
                  </div>
                  {t("salesAndCRM")}
                </div>
                <div className={styles.circleUser}>
                  <div className={styles.circleUserPhotoWrapper}>
                    <img src="/human-1.png" alt="" />
                  </div>
                  {t("marketing")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.pageFlex}>
          <div className={styles.templateInfoWrapper}>
            <div className={styles.textWrapperFlex}>
              <div className={styles.textWrapper}>
                <div className={styles.title}>{t("hrServiceDelivery")}</div>
                <div className={styles.description}>{t("hrServiceOverview")}</div>
              </div>
            </div>
            <div className={styles.templateInfoBottom}>
              <div className={styles.templateInfoLeft}>
                <div className={`${styles.templateInfoTextWrapper} ${activePreviewTab === 'form' ? styles.templateInfoTextWrapperActive : ""}`} onClick={() => setActivePreviewTab('form')}>
                  <div className={styles.templateInfoTitle}>
                    {t("form")}
                    <RightArrow />
                  </div>
                  {/* <div className={styles.templateInfoDescription}>
                    sdafkjasldkfjaklş
                  </div> */}
                </div>
                <div className={`${styles.templateInfoTextWrapper} ${activePreviewTab === 'workflow' ? styles.templateInfoTextWrapperActive : ""}`} onClick={() => setActivePreviewTab('workflow')}>
                  <div className={styles.templateInfoTitle}>
                    {t("workflowText")}
                    <RightArrow />
                  </div>
                  {/* <div className={styles.templateInfoDescription}>
                    asdkfjşkladsjfasdlşk
                  </div> */}
                </div>
              </div>
              <div className={styles.templateInfoRight}>
                {activePreviewTab === 'form' && (
                  <Image
                    className={styles.templateInfoRightImg}
                    src={isLanguage === "TR" ? `${IMAGE_DELIVERY}/dba34439-7c5c-4198-2f6e-df2562cf3900` : `${IMAGE_DELIVERY}/745dbc50-32ae-46e0-198a-5eb00fecd900`}
                    alt={""}
                    width={640}
                    height={808}
                    loader={(p: ImageLoaderProps) => imageLoader(p.src, 640, 808)}
                  />
                )}
                {activePreviewTab === 'workflow' && (
                  <Image
                    className={styles.templateInfoRightImg}
                    src={isLanguage === "TR" ? `${IMAGE_DELIVERY}/dc75004f-1c9f-4a78-dd63-13d723da6200` : `${IMAGE_DELIVERY}/a594aad8-34e4-452a-da1f-4b4bf8ee2300`}
                    alt={""}
                    width={460}
                    height={640}
                    loader={(p: ImageLoaderProps) => imageLoader(p.src, 460, 640)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.pageFlex}>
          <div className={styles.howToWrapper}>
            <div className={styles.textWrapper}>
              <div className={styles.title}>{t("howToImplementSolutions")}</div>
              {/* <div className={styles.description}>{t("manageServiceDisruptions")}</div> */}
            </div>
            <div className={styles.howToCardWrapper}>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepFirst />
                  <div className={styles.howToCardTitle}>{t("createOnboardingTaskPack")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("defineDepartmentChecklists")}</div>
              </div>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepSecond />
                  <div className={styles.howToCardTitle}>{t("standardizePolicyDocuments")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("setMandatoryFieldsAndTemplates")}</div>
              </div>
              <div className={styles.howToCard}>
                <div className={styles.howToCardTop}>
                  <StepThird />
                  <div className={styles.howToCardTitle}>{t("defineSlas")}</div>
                </div>
                <div className={styles.howToCardExplain}>{t("measureFirstDayReady")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', ['common'])),
  },
});

export default HrServiceDelivery;
